/*
    Vite does not currently provide out of the box support for jest
    and will break when attempting to import environment variables directly.

    This file should be used for importing these variables so that they
    can be mocked or stubbed out to avoid the above.

    For more information:
        - https://github.com/vitejs/vite/issues/1955
        - https://github.com/vitejs/vite/issues/1149
 */
export const metaEnv = import.meta.env;
